export default "__VITE_ASSET__onOz_lXJ$$4tjEEPf1NX1w__"